module.exports = __webpack_public_path__ + "img/new_index_industry_icon8.8318fff7.png";